<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19ZiF9i/tc-custom/9780545941099.jpg?1737806200741" alt="This image is the cover for the book Frozen Charlotte"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Frozen Charlotte
      </h1>
      <p class="bookDescription body article font2">
        <b>In this young adult horror novel, a girl staying on a remote island suspects the tiny Victoria-era dolls in her family’s old mansion are up to murder.</b><br/><br/>When her best friend dies under mysterious circumstances, Sophie sets off to stay with her cousins on the remote Isle of Skye. It’s been years since she last saw them—brooding Cameron with his scarred hand; Piper, who seems too perfect to be real; and peculiar little Lilias with her fear of bones. Still, Sophie never expected the strange new rules the family now lives by: Make no mention of Cameron’s accident. Never leave the front gate unlocked. Above all, don’t speak of the girl who’s no longer there, the sister whose death might have closer ties to Sophie’s past—and more sinister consequences for her future—than she ever knew.<br/><br/>A wondrously haunting and modern thriller, <i>Frozen Charlotte</i> drips with mystery and madness, secrets and survival, and the chilling sense that the impossible might be all too real.<br/><br/>“Teens looking for a novel to keep them up at night will find it in this one.” —<i>School Library Journal</i><br/><br/>“Gothic ghosts combine with crime for a fast read.” —<i>Kirkus</i><br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alex Bell
      </h2>
      
      <p class="authorDescription body article"> Alex Bell has published novels and short stories for both adults and young adults, including the fantasy <I>The Ninth Circle</I>. She lives in the UK. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Scholastic
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f301bce2